import React from 'react';
import { connect } from 'react-redux';
import { RouteComponentProps } from 'react-router';
import { Link } from 'react-router-dom';
import { Input, Button } from 'components';
import { AuthService } from 'services';
import { RootState } from 'reducers';
import { BgLogin } from 'assets/img';
import { ArrowLeft, PasswordActive, PasswordInactive } from 'assets/icons';
import { Globals } from 'utils';

declare var window: any;

interface Props extends RouteComponentProps<any> {
	dispatch: any
}

class Reset extends React.Component<Props> {

	state = {
		visible: false,
		form: {
			password: '',
			password_confirmation: ''
		},
		title: 'Ingrese su nueva contraseña'
	}

	async componentDidMount() {
		const res: any = await AuthService.checkCode({
			code: this.props.match.params.code
		});
		if (!res.result) {
			this.props.history.replace('/');
		}

		this.props.dispatch({
			type: 'SET_HEADER',
			payload: {
				title: 'Recuperación de Contraseña',
				onBack: null
			}
		});
	}

	change = (e: any) => {
		this.setState({
			form: {
				...this.state.form,
				[e.target.name]: e.target.value
			}
		});
	}

	isValidForm = () => {
		const onError = (msg: string) => {
			Globals.showError(msg);
			return false;
		}

		const { form } = this.state;

		if (!form.password)
			return onError('Debe ingresar la contraseña');

		if (form.password !== form.password_confirmation)
			return onError('Las contraseñas no coinciden');

		return true;
	}

	submit = async (e: React.FormEvent<HTMLFormElement>) => {
		e.preventDefault();

		if (!this.isValidForm()) return;

		await AuthService.reset({
			code: this.props.match.params.code,
			...this.state.form,
		});
		this.props.history.replace('/success-password');
		Globals.showSuccess("Se ha cambiado su contraseña correctamente");
	}
	
	render() {

		const { form, visible } = this.state;

		return (
			<div id="reset">
				<div className="row container-form">
					<div className="col-lg-6 container-bg" style={{ backgroundImage: `url(${ BgLogin })` }}>
						{/* <img src={ LoginSlogan } className="logo" alt="Logo" /> */}
					</div>
					<div className="col-lg-6">
						<div className="row row-title">
							<div className="col-2">
								<Link to="/login">
									<img src={ ArrowLeft } className="arrow-left-green" alt="Volver" />
								</Link>
							</div>
							<div className="col-8">
								<h3 className="title-green">{ this.state.title }</h3>
							</div>
						</div>

						<form className="container-input" onSubmit={this.submit}>
							<Input
								label="Contraseña"
								placeholder="Escribe tu contraseña"
								type={ visible ? 'text' : 'password' }
								name="password"
								value={form.password}
								onChange={ this.change }
								searchRight
								searchIcon={ this.state.visible ? PasswordActive : PasswordInactive }
								onSubmit={ () => this.setState({ visible: !this.state.visible }) }
							/>
							<Input
								label="Repetir Contraseña"
								placeholder="Escribe tu contraseña"
								type={ visible ? 'text' : 'password' }
								name="password_confirmation"
								value={form.password_confirmation}
								onChange={ this.change }
								searchRight
								searchIcon={ this.state.visible ? PasswordActive : PasswordInactive }
								onSubmit={ () => this.setState({ visible: !this.state.visible }) }
							/>

							<div className="text-center">
								<Button type="submit" color="secondary">Guardar</Button>
							</div>
						</form>
					</div>
				</div>
			</div>
		)
	}
}

export default connect((state: RootState) => {
	return {
		user: state.user
	}
})(Reset);